import { Button, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import { PiNavigationArrow } from 'react-icons/pi';
import { useGetClientUserAccounts } from 'services/clientUserManagment';

const ClientUserAccountsTab = () => {
  const id = useParamId();
  const accounts = useGetClientUserAccounts(id);
  const navigateToNewWindow = useNewWindowNavigate();
  return (
    <Table
      data={{ nodes: accounts.data ?? [] }}
      loading={accounts.isLoading}
      size='compact'
      columns={[
        {
          label: t('input.label.account'),
          renderCell: ({ labelName }) => (
            <TableItem>
              <TableItem.Text text={labelName ?? undefined} />
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: ({ id }) => (
            <TableItem justifyPosition='end'>
              <Button
                isClear
                onlyIcon
                onClick={() =>
                  navigateToNewWindow(`client-account/${id}/users`)
                }>
                <Button.Icon
                  icon={<PiNavigationArrow transform='scale(-1,1)' />}
                />
              </Button>
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default ClientUserAccountsTab;
